export default __webpack_public_path__ + "static/media/loader.3e23ff11.gif";